import { render, staticRenderFns } from "./GatButtonMenuItem.vue?vue&type=template&id=5d236850&scoped=true&"
import script from "./GatButtonMenuItem.vue?vue&type=script&lang=js&"
export * from "./GatButtonMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d236850",
  null
  
)

export default component.exports